import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Attachment } from "../types";
import "swiper/css";

interface ImagePreviewerProps {
  selectedImage: string;
  carouselItems: Attachment[];
  onClose: () => void;
  onChange: (imageUrl: string) => void;
}

export default function ImagePreviewer({
  selectedImage,
  carouselItems,
  onClose,
  onChange,
}: ImagePreviewerProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // 组件挂载后立即设置为可见，触发淡入动画
    setIsVisible(true);
  }, []);

  const handleClose = () => {
    // 先触发淡出动画，然后关闭
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // 等待动画完成
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full z-[100] bg-black/90 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      {/* Close button */}
      <button
        onClick={handleClose}
        className="absolute top-4 right-4 z-60 w-10 h-10 bg-white/20 text-white rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-200 backdrop-blur-sm"
        aria-label="关闭预览"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Image preview */}
      <div className="w-full h-full flex items-center justify-center">
        <Swiper
          className="h-[80%]"
          spaceBetween={16}
          initialSlide={carouselItems.findIndex((item) => item.url === selectedImage)}
          onSlideChange={(swiper) => {
            const newImage = carouselItems[swiper.activeIndex]?.url;
            if (newImage) {
              onChange(newImage);
            }
          }}
        >
          {carouselItems.map((item, index) => (
            <SwiperSlide key={index} onClick={handleClose}>
              <div className="w-full h-full flex items-center justify-center">
                <img
                  src={item.url}
                  alt={item.name}
                  className="max-w-full max-h-full object-contain transition-opacity duration-300"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Image counter */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-60">
        <div className="text-white px-3 py-1 rounded-full backdrop-blur-sm bg-black/20">
          <span className="text-sm font-medium">
            {carouselItems.findIndex((item) => item.url === selectedImage) + 1}{" "} / {carouselItems.length}
          </span>
        </div>
      </div>
    </div>
  );
}
